import { render, staticRenderFns } from "./Warranty.vue?vue&type=template&id=c9f18ef2&scoped=true&"
import script from "./Warranty.vue?vue&type=script&setup=true&lang=js&"
export * from "./Warranty.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Warranty.vue?vue&type=style&index=0&id=c9f18ef2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f18ef2",
  null
  
)

export default component.exports